// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".go_top[data-v-2f79a5d8]{opacity:0;transition:opacity .2s,transform .8s;width:21.0666666667%;right:7px;bottom:7px;position:fixed;z-index:200}.go_top.is-show[data-v-2f79a5d8]{opacity:1}", ""]);
// Exports
module.exports = exports;
